/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateCampaignDataStatusSchema = z.enum(['draft', 'review', 'publishing', 'active', 'completed'])

export type UpdateCampaignDataStatusSchema = z.infer<typeof updateCampaignDataStatusSchema>
